import { render, staticRenderFns } from "./ContentBlog.vue?vue&type=template&id=b9263274"
import script from "./ContentBlog.vue?vue&type=script&lang=js"
export * from "./ContentBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports